var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Ministerio de Salud"}},[_c('b-card-text',[_vm._v("Estadística Vectores")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }